module.exports = __webpack_public_path__ + "img/pg3-article3-c4.8eb94569.png";